export const WEB_APP_URL =
  process.env.REACT_APP_APP_ENV === "dev"
    ? "https://test.tikler.io"
    : "https://app.tikler.io";

export const BACKEND_URL =
  process.env.REACT_APP_APP_ENV === "dev"
    ? "https://testadmin.tikler.io"
    : "https://admin.tikler.io";

// export const BACKEND_URL =
//   process.env.REACT_APP_APP_ENV === "dev"
//     ? "http://localhost:8000"
//     : "https://admin.tikler.io";
